import { render, staticRenderFns } from "./TooltipAniversarios.vue?vue&type=template&id=69bd52eb"
import script from "./TooltipAniversarios.vue?vue&type=script&lang=js"
export * from "./TooltipAniversarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports